import {
  InventoryExportPreset,
  GetInventoryExportPresetListSuccessResponseAllOfResult,
  InventoryExportPresetUpsertRequest,
} from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { IInventoryTemplatePreset, IInventoryTemplatePresetUpsertRequest, OutputFormat } from '../domains/entities/InventoryTemplate';

/**
 * 出力条件プリセットAPIレスポンスをドメインへ変換するアダプタ
 */
export class InventoryTemplatePresetAdapter {
  /**
   * APIの1件分をエンティティへ変換する
   * @param preset - APIレスポンスの1件
   */
  public static toEntity = (preset: InventoryExportPreset): IInventoryTemplatePreset => {
    return {
      presetId: preset.presetId,
      name: preset.name,
      masterItemKeys: preset.masterItems,
      outputDataItemKeys: preset.outputDataItems,
      singleFieldPositions: preset.singleFieldPositions ?? null,
      startMonthOffset: preset.startMonthOffset,
      endMonthOffset: preset.endMonthOffset,
      outputFormat: preset.outputFormat as OutputFormat,
    };
  };

  /**
   * 一覧レスポンスをエンティティ配列へ変換する
   * @param listResult - APIの一覧レスポンス
   */
  public static toEntities = (listResult: GetInventoryExportPresetListSuccessResponseAllOfResult): IInventoryTemplatePreset[] => {
    return listResult.presets.map(InventoryTemplatePresetAdapter.toEntity);
  };

  /**
   * 登録・更新リクエストをAPI形式へ変換する
   * @param request - 登録・更新リクエスト
   */
  public static toApiUpsertRequest = (request: IInventoryTemplatePresetUpsertRequest): InventoryExportPresetUpsertRequest => {
    return {
      name: request.name,
      masterItems: request.masterItems,
      outputDataItems: request.outputDataItems,
      singleFieldPositions: request.singleFieldPositions ?? undefined,
      startMonthOffset: request.startMonthOffset,
      endMonthOffset: request.endMonthOffset,
      outputFormat: request.outputFormat,
    };
  };
}
